import { useEffect, useRef } from 'react';
import { EVENT_ENUMS, trackNamedEvent } from './userJourneyTracker';

/**
 * On load: if URL has push_nid (from notification click), record journey + backend click.
 */
export function usePushAttribution(isAuthenticated, idToken) {
  const handledRef = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || !idToken || handledRef.current) return;

    const params = new URLSearchParams(window.location.search);
    const pushNid = (params.get('push_nid') || '').trim();
    if (!pushNid) return;

    handledRef.current = true;

    trackNamedEvent(EVENT_ENUMS.PUSH_NOTIFICATION_OPENED, {
      push_nid: pushNid,
      utm_source: params.get('utm_source') || 'web_push',
      utm_campaign: params.get('utm_campaign') || 'streak_reminder',
    });

    fetch('/api/push/opened', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`,
      },
      body: JSON.stringify({ push_nid: pushNid }),
    }).catch(() => {});

    params.delete('push_nid');
    params.delete('utm_source');
    params.delete('utm_medium');
    params.delete('utm_campaign');
    const qs = params.toString();
    const next = `${window.location.pathname}${qs ? `?${qs}` : ''}${window.location.hash || ''}`;
    window.history.replaceState({}, '', next);
  }, [isAuthenticated, idToken]);
}
